import React, { useState, useCallback } from 'react';
import PullToRefresh from 'react-simple-pull-to-refresh';
import Sidebar from './Sidebar';
import Header from './Header';
import { RefreshCw } from 'lucide-react';

// Pages that have their own headers
const PAGES_WITH_OWN_HEADER = ['work-planner', 'day-pilot', 'visual-planner', 'invoices', 'owing', 'reports', 'settings', 'stripe-sync', 'gocardless-sync', 'send', 'expenses', 'expense-categories', 'chart-of-accounts', 'reporting', 'connected-apps', 'sync-centre', 'bank-transactions', 'api-docs'];

// Custom refresh indicator component
const RefreshIndicator = () => (
  <div className="flex items-center justify-center py-4">
    <RefreshCw className="w-6 h-6 text-emerald-500 animate-spin" />
    <span className="ml-2 text-sm text-slate-600">Refreshing...</span>
  </div>
);

// Pull indicator during pull gesture
const PullIndicator = () => (
  <div className="flex items-center justify-center py-4">
    <RefreshCw className="w-6 h-6 text-slate-400" />
    <span className="ml-2 text-sm text-slate-500">Pull to refresh</span>
  </div>
);

const Layout = ({ children, currentPage, setCurrentPage, onHeaderNavigate, user, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const hideHeader = PAGES_WITH_OWN_HEADER.includes(currentPage);

  const handleSearch = (query) => {
    // Navigate to customers with search query
    setCurrentPage('customers');
    // Could also set a search state here if needed
    console.log('Search:', query);
  };

  // Handle pull-to-refresh - performs hard refresh
  const handleRefresh = useCallback(async () => {
    // Small delay to show the refresh animation
    await new Promise(resolve => setTimeout(resolve, 500));
    // Hard refresh the page
    window.location.reload();
  }, []);

  return (
    <div className="flex h-screen bg-gray-100 overflow-hidden">
      {/* Sidebar */}
      <Sidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        user={user}
        onLogout={onLogout}
      />
      
      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        {!hideHeader && (
          <Header 
            onMenuClick={() => setSidebarOpen(true)} 
            user={user} 
            onNavigate={onHeaderNavigate || setCurrentPage}
            onSearch={handleSearch}
          />
        )}
        <PullToRefresh
          onRefresh={handleRefresh}
          pullingContent={<PullIndicator />}
          refreshingContent={<RefreshIndicator />}
          pullDownThreshold={150}
          maxPullDownDistance={200}
          resistance={3}
          className="flex-1 overflow-hidden"
        >
          <main 
            className="h-full overflow-y-auto overflow-x-hidden"
            data-testid="main-content-area"
          >
            {React.cloneElement(children, { onMenuClick: () => setSidebarOpen(true) })}
          </main>
        </PullToRefresh>
      </div>
    </div>
  );
};

export default Layout;